import { Card } from "antd";
import { EventHandler, useEffect } from "react";
import styles from "../styles/modal-layout.module.scss";
import helperStyles from "../styles/helpers.module.scss";
import { ReactComponent as CloseSVG } from "../assets/close2.svg";
import CenterDiv from "../atomics/center-div";

export type ModalLayoutProps = {
    title?: string;
    children?: any;
    show: boolean;
    showCloseClick?: boolean;
    onCloseClick?: EventHandler<any>;
};

const ModalLayout = (props: ModalLayoutProps) => {
    useEffect(() => {
        if (props.show) {
            document.body.style.overflow = "hidden";
        } else document.body.style.overflow = "scroll";
    }, [props.show]);
    return (
        <div
            className={props.show ? styles.lightboxContainer : `${styles.lightboxContainer} ${helperStyles.hide}`}
            style={props.show ? { top: document.documentElement.scrollTop } : undefined}
        >
            <Card className={styles.lightbox}>
                {props.showCloseClick !== false && (
                    <div
                    className={styles.closeButton}
                        onClick={() => {
                            if (props.onCloseClick) props.onCloseClick(!props.show);
                        }}
                    >
                        <CloseSVG/>
                    </div>
                )}
                <CenterDiv>
                    <h3 className={styles.titleMessage}>{props.title}</h3>
                </CenterDiv>
                {props.children}
            </Card>
        </div>
    );
};

export default ModalLayout;
